module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-322.f9cee95.woff2";